module.exports = __webpack_public_path__ + "static/media/comuu1.3d1a610d.jpg";